import {Epic} from 'redux-observable'
import {filter, mergeMap} from 'rxjs/operators'
import {invalidateCacheAction, refreshBSModelAction} from 'module/BSCollection/action/BSCollectionAction'
import {selBSCollectionByIdDict} from 'module/BSCollection/selector/BSCollectionSelector'
import {SisName} from 'util/SisName'
import {Persurl} from 'generated/JavaTOmodifications'
import {ById} from 'util/redux/ReduxHelperTypes'
import {parseSisDate} from 'util/SisDateTime'

const InvalidatePersurlCacheEpic: Epic = (action$, state$) => action$.pipe(
	filter(refreshBSModelAction.match),
	mergeMap(({payload: {remove, add}}) => {
		const byId = selBSCollectionByIdDict[SisName.Persurl]?.(state$.value)
		if (!byId) return []
		return [...(remove || []), ...(add || [])].flatMap(model => {
			if (!model || model.sisName !== SisName.Persurl) return []
			// persurl implementation does not send deleted items -> manually find overlapping and remove from local cache
			const persNr = (model as Persurl).persNr
			const {start, end} = Object.values(byId as ById<Persurl>)
				.reduce((ret, x: Persurl) => {
					if (x.persNr === model.persNr && x.start <= model.end && x.end >= model.start) {
						if (x.start < ret.start) ret.start = x.start
						if (x.end > ret.end) ret.end = x.end
					}
					return ret
				}, {start: model.start, end: model.end})
			return [invalidateCacheAction({
				sisName: SisName.Persurl,
				owners: [persNr],
				startTS: +parseSisDate(start),
				endTS: +parseSisDate(end).endOf('day'),
			})]
		})
	}),
)

export const BSPersurlEpic = InvalidatePersurlCacheEpic